import {CardDescription} from '../types';

export const getCardCodes = (cardTypes: CardDescription[]): string => {
  return cardTypes.map(({code}) => code).join(',');
};
